import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import HistorizationBannerViewModel from '@/ViewModels/Controls/HistorizationBannerViewModel';
import HistorizationBanner from '@/Controls/HistorizationBanner';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';

export default class HistorizationBannerFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private HistorizationBannerViewModel = ComponentManager.getViewModel<typeof HistorizationBannerViewModel>('HistorizationBannerViewModel');
    private HistorizationBanner = ComponentManager.getControl<typeof HistorizationBanner>('HistorizationBanner');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');

    public constructor(params: any) {
        super(params);

        this.labelPosition = this.paramOrDefault('None');
    }

    /**
     * @override
     */
    control: HistorizationBanner;
    /**
     * @override
     */
    viewModel: HistorizationBannerViewModel;

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = new this.HistorizationBannerViewModel({
            parentLocator: this.locator,
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            }),
            locator: this.detailViewItem.name,
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            invalidationText: this.invalidationText,
            value: this.context.genericObject.getObservable(this.detailViewItem.name + '.Value')
        });

        this.control = new this.HistorizationBanner(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        return this.jQueryControl;
    }
}

ComponentManager.setFactory('HistorizationBanner', HistorizationBannerFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');